import moment from 'moment';
import { Translation } from 'react-i18next';

export const pluralize = (value: number | string, unit: string, unitPlural?: string) => {
  const number = parseInt(value, 10);
  if (unitPlural && number !== 1) {
    return `${number} ${unitPlural}`;
  }
  const string = `${number === 0 ? '0' : number} ${unit}`;
  const plural = number === 1 ? '' : 's';
  return string + plural;
};

// Formats that the backend sends date strings in
export const backendDateFormats = ['YYYY-MM-DD[T]HH:mm:ss[Z]', 'YYYY-MM-DD[T]HH:mm:ssZ', 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'];

export const formatDate = (date: string | number) => moment.parseZone(date).format('ll');
export const formatDateTime = (date: string | number) => moment.parseZone(date).format('lll');

export const extractUnit = (text: string) => {
  const units = ['capsule', 'tablet', 'drop', 'spray'];

  const matches = units.filter((unit) => {
    if (text) { return text.indexOf(unit) > -1; }
    return null;
  });

  if (matches && matches.length > 0) {
    const match = matches[0];
    if (match === 'drop' || match === 'spray') { return 'bottle'; }
    return match;
  }

  return 'unit';
};

export const toSentenceCase = (string: string) => (
  string && string.length > 0
    ? `${string.substring(0, 1).toUpperCase()}${string.substring(1).toLowerCase()}`
    : string
);


export const formatPhoneNumber = (text: string) => {
  // extract numeric input
  const digits = text.split('').filter((character) => '0123456789'.indexOf(character) > -1).join('');

  let countryCode = '';
  let areaCode = '';
  let threeDigits = '';
  let fourDigits = '';

  if (digits.length <= 3) return digits;
  else if (digits.length < 7) {
    areaCode = digits.slice(0, 3);
    threeDigits = digits.slice(3);
    return `(${areaCode}) ${threeDigits}`;
  } else if (digits.length < 11) {
    areaCode = digits.slice(0, 3);
    threeDigits = digits.slice(3, 6);
    fourDigits = digits.slice(6);
  } else if (digits.length === 11) {
    countryCode = digits[0];
    areaCode = digits.slice(1, 4);
    threeDigits = digits.slice(4, 7);
    fourDigits = digits.slice(7);
  } else {
    return digits; // invalid: too many numbers
  }
  return `${countryCode} (${areaCode}) ${threeDigits}-${fourDigits}`.trim();
};

/*
  In order to render text contained in Translations, you can usually just render the Translation and
  React will display the text.
  But in order to render a Translation *as* a string, e.g. to concatenate a translation with another string,
  we cannot do `Name: ${<Translation ...></Translation>}` - this will render as "Name: [Object object]".

  We can, however, concatenate Translations and strings within an array, and React will render
  each of the array items side by side.
*/
export const concatTranslations = (...text: Translation | string) => [...text];



// WEBPACK FOOTER //
// ./src/utils/format.js